// Marketing-site brand lockup: icon mark + wordmark (image-based, matches the
// app brand). In the landing nav the wordmark collapses away once the page is
// scrolled, leaving just the icon — driven by the
// `#lp-site-header.scrolled .lp-brand-wordmark` rule in index.css. Elsewhere
// (footer, legal/book-demo headers) there's no `.scrolled` ancestor, so both
// stay visible. The icon carries the accessible name since it's the element
// that persists; the wordmark is decorative.
export function MarketingBrand() {
  return (
    <span className="lp-brand">
      <img src="/bidcontext-logo.png" alt="BidContext" className="lp-brand-mark" />
      <img src="/bidcontext-wordmark.png" alt="" className="lp-brand-wordmark" />
    </span>
  )
}
